export default "__VITE_ASSET__e38cf768__"